import React, {useEffect, useMemo, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PolicyHoldersService from "../../../services/PolicyHoldersService";
import Spinner from "reactjs-simple-spinner";
import {toast, ToastContainer} from "react-toastify";
import PersonPinIcon from '@material-ui/icons/PersonPin';
import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "./policies/tableComponent/EnhancedTable";
import PoliciesService from "../../../services/PoliciesService";


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

const ViewPolicyHolder = (props) => {

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [policyHolder, setPolicyHolder] = useState({});
    const [policyHolderId, setPolicyHolderId] = useState('');
    const [loading, setLoading] = useState(true);
    const [addButton, setAddButton] = useState(false)


    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    let history = useHistory();

    const columns = useMemo(
        () => [
            {
                Header: 'Policy #',
                accessor: 'policy_number',
            },
            {
                Header: 'Policy Status',
                accessor: 'policy_status',
            },
            {
                Header: 'Contract Premium',
                accessor: 'total_premium',
            },
            {
                Header: 'Policy Type',
                accessor: 'policy_type',
            },
            {
                Header: 'Policy Currency',
                accessor: 'policy_currency',
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({value, row}) => (
                    <>
                          <span>
        <Link className="btn btn-sm btn-primary" onClick={() => viewPolicy(value, row)}>
            <i className="fa fa-eye">&nbsp;</i>View
        </Link>
                               <Link className="btn btn-sm btn-warning" onClick={() => editPolicy(value, row)}>
            <i className="fa fa-edit">&nbsp;</i>Edit
        </Link>
                               <Link className="btn btn-sm btn-danger" onClick={() => deletePolicy(row)}>
            <i className="fa fa-trash">&nbsp;</i>Delete
        </Link>
                          </span>
                    </>

                )
            },
        ],
        []
    )

    //view PolicyHolder
    const viewPolicy = (value, row) => {
        console.log(value);
        console.log("row: ", row.original);
        //store row record into localStorage
        localStorage.setItem('policyNumber', JSON.stringify(row.original.policy_number));
        localStorage.setItem('policyId', JSON.stringify(row.original.id));
        localStorage.setItem('policy', JSON.stringify(row.original));
        if (row.original.policy_type === 'PFUMA / INOTHO') {
            history.push('/view-ilifa');
        } else {
            history.push('/view-policy');
        }

    }

    //open edit screen
    const editPolicy = (value, row) => {
        console.log(value);
        console.log("row: ", row.original);
        //store row record into localStorage
        localStorage.setItem('policyNumber', JSON.stringify(row.original.policy_number));
        localStorage.setItem('policy', JSON.stringify(row.original));

        let policyType = row.original.policy_type;
        //redirect to the specific page
        console.log(policyType === 'COMPREHENSIVE');
        if (row.original.policy_type === 'ACCIDENT') {
            history.push('/edit-accident');
        } else if (row.original.policy_type === 'FUNERAL') {
            history.push('/edit-funeral');
        } else if (row.original.policy_type === 'SAVINGS') {
            history.push('/edit-savings');
        } else if (row.original.policy_type === 'COMPREHENSIVE') {
            history.push('/edit-comprehensive');
        } else if (row.original.policy_type == 'PFUMA / INOTHO') {
            history.push('/edit-ilifa');
        }

    }

    const deletePolicy = (row) => {
        setLoading(true);
        console.log(value);
        console.log("row: ", row.original);
        PoliciesService.deletePolicy(row.original.id)
            .then(res => {
                console.log("response: ", res)
                if (res.status === 200) {
                    const pH = JSON.parse(localStorage.getItem('policyHolderId'));
                    setPolicyHolderId(pH);
                    console.log("data: ", pH);
                    PolicyHoldersService.getPolicyHolder(pH)
                        .then(res => {
                            console.log(res);
                            setPolicyHolder(res.data.policyHolder);
                            localStorage.setItem("pHolder", JSON.stringify(res.data.policyHolder));
                            let pHolder = {
                                "title": res.data.policyHolder.title,
                                "firstname": res.data.policyHolder.first_name,
                                "lastname": res.data.policyHolder.last_name
                            }
                            setData(res.data.policies)
                            localStorage.setItem("policyHolder", JSON.stringify(pHolder));
                            //store policies on localStorage
                            localStorage.setItem("policies", JSON.stringify(res.data.policies));
                            toast('Policy deleted successfully', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            setLoading(false);
                        })
                        .catch(err => {
                            console.log(err);
                            setLoading(false);
                        });

                } else {
                    console.log("error: ", res);
                    toast.error('Deleting request failed, If error persists contact, System Administrator', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(err => {
                console.log("error: ", err);
                toast.error('Deleting request failed, If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })

    }


    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)
    const [showButton, setShowButton] = useState(true);


    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setAddButton(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'add policies') {
                    setAddButton(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setAddButton(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'add policies') {
                    setAddButton(true);
                }
            })
        }
        const pH = JSON.parse(localStorage.getItem('policyHolderId'));
        setPolicyHolderId(pH);
        console.log("data: ", pH);
        PolicyHoldersService.getPolicyHolder(pH)
            .then(res => {
                console.log(res);
                setPolicyHolder(res.data.policyHolder);
                localStorage.setItem("pHolder", JSON.stringify(res.data.policyHolder));
                let pHolder = {
                    "title": res.data.policyHolder.title,
                    "firstname": res.data.policyHolder.first_name,
                    "lastname": res.data.policyHolder.last_name
                }
                setData(res.data.policies)
                localStorage.setItem("policyHolder", JSON.stringify(pHolder));
                //store policies on localStorage
                localStorage.setItem("policies", JSON.stringify(res.data.policies));
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
            });
    }, []);


    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                {loading && (
                    <div className="container">
                        <form className="loader">
                            <div className="login-wrap p-5 mt-5">
                                <Spinner
                                    size="large"
                                    message="Please Wait..."
                                    line-fg-color="#64c3c2"
                                />
                            </div>
                        </form>
                    </div>
                )}
                {!loading && (
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                 &nbsp;|&nbsp;
                                <Link to="/policy-holders"><a href><i className="fa fa-users"/> Leads</a></Link>
                                 &nbsp;|&nbsp;
                                <span
                                    className="text-capitalize">
                                    View Policy Holder</span>
                            </ul>

                            {/*    Tabs Navigation*/}
                            <div className={classes.root}>
                                <Paper square>
                                    <Tabs indicatorColor="primary"
                                          textColor="primary" value={value}
                                          aria-label="simple tabs example"
                                          centered>
                                        <Tab
                                            icon={<PersonPinIcon/>}
                                            label={policyHolder.title + " " + policyHolder.first_name + " " + policyHolder.last_name + ' Details'}
                                            {...a11yProps(0)}
                                        />
                                    </Tabs>
                                </Paper>
                                <TabPanel value={value} index={0}>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <hr/>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h4 className="text-primary"><strong>General Information</strong>
                                                    </h4>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4><b>Name:</b> <span
                                                        className="text-capitalize">{policyHolder.title}&nbsp;{policyHolder.first_name}&nbsp;{policyHolder.last_name}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Occupation:</b> <span
                                                        className="text-capitalize">{policyHolder.occupation}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Date of Birth:</b> <span
                                                        className="text-uppercase text-capitalize">{policyHolder.date_of_birth}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Gender:</b> <span
                                                        className="text-capitalize">{policyHolder.gender}</span></h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Marital Status: </b> <span
                                                        className="text-capitalize">{policyHolder.status}</span></h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>ID Number: </b>
                                                        <span
                                                            className="text-capitalize">{policyHolder.id_number}</span>
                                                    </h4>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Smokers Status:</b> <span
                                                        className="text-capitalize">{policyHolder.smoker_status}</span>
                                                    </h4>

                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>Salary:</b> <span
                                                        className="text-uppercase">{policyHolder.salary}</span></h4>

                                                </div>
                                                <div className="col-md-6">
                                                    <h4><b>EC Number:</b> <span
                                                        className="text-uppercase">{policyHolder.ec_number}</span></h4>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <hr/>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h4 className="text-primary"><strong>Contact Details</strong></h4>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4><strong>Mobile Number</strong></h4>
                                                    <span className="text-uppercase">{policyHolder.mobile}</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><strong>Alternative Number</strong></h4>
                                                    <span
                                                        className="text-uppercase">{policyHolder.work_telephone}</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <h4><strong>Email</strong></h4>
                                                    <span className="text-lowercase">{policyHolder.email}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4 className="text-primary"><strong>Address Details</strong></h4>
                                        </div>
                                        <div className="col-md-6">
                                            <h4 className="font-weight-bold">Physical Address</h4>
                                            <address>
                                                <span className="font-weight-bold">Street: </span>
                                                <span
                                            >{policyHolder.physical_address_street}</span>
                                                <br/>
                                                <span className="font-weight-bold">&nbsp;Suburb: </span>
                                                <span
                                            >{policyHolder.physical_address_suburb}</span>
                                                <br/>
                                                <span className="font-weight-bold">&nbsp; City: </span> <span
                                            >{policyHolder.physical_address_city}</span>
                                            </address>
                                        </div>
                                        <div className="col-md-6">
                                            <h4 className="font-weight-bold">Postal Address</h4>
                                            <address>
                                                <span className="font-weight-bold">Street:</span> <span
                                            >{policyHolder.postal_address_street}</span>
                                                <br/>
                                                <span className="font-weight-bold">&nbsp;Suburb: </span> <span
                                            >{policyHolder.postal_address_suburb}</span>
                                                <br/>
                                                <span className="font-weight-bold">&nbsp;City: </span> <span
                                            >{policyHolder.postal_address_city}</span>
                                            </address>
                                        </div>
                                    </div>
                                    <hr/>

                                    <div className="row">
                                        <div className="col-md-12 row">
                                            <div className="col-md-4">
                                                <h4 className="text-primary"><strong>Policies
                                                </strong>
                                                </h4>
                                            </div>
                                        </div>

                                    </div>
                                    {addButton && (
                                        <div className="row">
                                            <div className="col-md-3 col-lg-3 col-sm-6 col-xs-6">
                                                <Link to={'/allocate-accident'} className="btn btn-sm btn-primary p-2">
                                                    <i className="fa fa-check-circle"/> Allocate Accident Plan</Link>
                                            </div>
                                            <div className="col-md-3 col-lg-3 col-sm-6 col-xs-6">
                                                <Link to={'/allocate-comprehensive'}
                                                      className="btn btn-sm btn-primary p-2">
                                                    <i className="fa fa-check-circle"/> Allocate
                                                    Comprehensive Funeral</Link>
                                            </div>
                                            <div className="col-md-3 col-lg-3 col-sm-6 col-xs-6">
                                                <Link to={'/allocate-funeral'} className="btn btn-sm btn-primary p-2">
                                                    <i className="fa fa-check-circle"/> Allocate Standard
                                                    Funeral</Link>
                                            </div>
                                            <div className="col-md-3 col-lg-3 col-sm-6 col-xs-6">
                                                <Link to={'/allocate-savings'} className="btn btn-sm btn-primary p-2">
                                                    <i className="fa fa-check-circle"/> Allocate Savings Plan</Link>
                                            </div>
                                            <div className="col-md-3 col-lg-3 col-sm-6 col-xs-6">
                                                <Link to={'/allocate-ilifa'} className="btn btn-sm btn-primary p-2">
                                                    <i className="fa fa-check-circle"/> Allocate Pfuma / Inotho</Link>
                                            </div>
                                        </div>
                                    )}

                                    <hr/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <>
                                                <CssBaseline/>
                                                <EnhancedTable
                                                    columns={columns}
                                                    data={data}
                                                    margin="dense"
                                                    setData={setData}
                                                    updateMyData={updateMyData}
                                                    skipPageReset={skipPageReset}
                                                />
                                            </>
                                        </div>
                                    </div>
                                    <hr/>


                                </TabPanel>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default ViewPolicyHolder;
